import {Component} from '@angular/core';

@Component({
    selector: 'qa-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent {

}
